/**
 * File: src/services/config-envelope-service.js
 * Mô tả: Dịch vụ đóng gói mã hóa XOR/Base64 và giải mã file cấu hình game tĩnh cho Game Client.
 * Liên quan: src/services/admin-config-service.js, docs/GAME_PORTAL_ADMIN_CONFIG_PLAN.md
 */

const SECRET_KEY = 'SNT_GAMES_ANT_CLASH_2026';

/**
 * Mã hóa dữ liệu JSON thành chuỗi Encrypted Base64
 * @param {Object} jsonObject 
 * @returns {string}
 */
export const encodeConfigPayload = (jsonObject) => {
  try {
    const jsonString = JSON.stringify(jsonObject);
    let encrypted = '';
    for (let i = 0; i < jsonString.length; i++) {
      const charCode = jsonString.charCodeAt(i) ^ SECRET_KEY.charCodeAt(i % SECRET_KEY.length);
      encrypted += String.fromCharCode(charCode);
    }
    return btoa(unescape(encodeURIComponent(encrypted)));
  } catch (error) {
    console.error('Lỗi khi mã hóa config payload:', error);
    return '';
  }
};

/**
 * Giải mã chuỗi Encrypted Base64 về lại JSON object
 * @param {string} encryptedBase64 
 * @returns {Object|null}
 */
export const decodeConfigPayload = (encryptedBase64) => {
  try {
    const encryptedStr = decodeURIComponent(escape(atob(encryptedBase64)));
    let jsonString = '';
    for (let i = 0; i < encryptedStr.length; i++) {
      const charCode = encryptedStr.charCodeAt(i) ^ SECRET_KEY.charCodeAt(i % SECRET_KEY.length);
      jsonString += String.fromCharCode(charCode);
    }
    return JSON.parse(jsonString);
  } catch (error) {
    console.error('Lỗi khi giải mã config payload:', error);
    return null;
  }
};

/**
 * Đóng gói Envelope đầy đủ chứa thông tin phiên bản và dữ liệu mã hóa
 * @param {string} gameId 
 * @param {string} version 
 * @param {Object} rawConfig 
 * @returns {Object}
 */
export const createConfigEnvelope = (gameId, version, rawConfig) => {
  return {
    gameId,
    version,
    updatedAt: new Date().toISOString(),
    configUrl: `/config/${gameId}/${version}/game-config.bin`,
    payload: encodeConfigPayload(rawConfig),
  };
};
